import DoneIcon from '@mui/icons-material/DoneRounded';
import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';

interface Props {
  applyPreset: () => void;
}

export function PresetAppliedContent({ applyPreset }: Props) {
  useEffect(() => {
    applyPreset();
  }, [applyPreset]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <DoneIcon sx={{ width: 48, height: 48 }} color="success" />
      <Typography align="center">Preset successfully imported</Typography>
    </Box>
  );
}
